import React from "react";

import svg from "../../assets/images/icons/Form Controls/Currency Field.svg";

export const CurrencyIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Currency"}
    />
);
